import { render } from "./AppPrestitosiTopbar.vue?vue&type=template&id=bb59fa20"
import script from "./AppPrestitosiTopbar.vue?vue&type=script&lang=js"
export * from "./AppPrestitosiTopbar.vue?vue&type=script&lang=js"

import "./AppPrestitosiTopbar.vue?vue&type=style&index=0&id=bb59fa20&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\prestito-si-front-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__